import { useLang } from "../i18n";
import { Reveal } from "./Reveal";

export const QuoteBand = () => {
  const { t } = useLang();

  return (
    <section className="px-5 py-24 sm:px-8 md:py-32">
      <div className="mx-auto max-w-5xl">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-volt">{t.quote.by}</p>
          <blockquote className="mt-8 font-display text-3xl font-bold leading-[1.15] tracking-tight sm:text-4xl md:text-5xl">
            <span className="text-volt">“</span>
            {t.quote.text}
            <span className="text-volt">”</span>
          </blockquote>
        </Reveal>
      </div>
    </section>
  );
};
